import { ToastContainer } from "react-toastify";
import "./App.css";
import { AuthProvider } from "./context/AuthContext";
import { SolarStationFormProvider } from "./context/FormContext";
import AppRouter from "./router/AppRouter";


function App() {
  return (
    <>
      <ToastContainer />
      <AuthProvider>
        <SolarStationFormProvider>
          <AppRouter />
        </SolarStationFormProvider>
      </AuthProvider>
      ,
    </>
  );
}

export default App;
